"use strict";
exports.__esModule = true;
var types_1 = require("../../types");
/**
 * @method createGetTips
 *
 * @memberof module:core
 *
 * @param {Provider} provider - Network provider
 *
 * @return {function} {@link #module_core.getTips `getTips`}
 */
exports.createGetTips = function (_a) {
    var send = _a.send;
    /**
     * Returns a list of tips (transactions not referenced by other transactions),
     * as seen by the connected node.
     *
     * @example
     *
     * ```js
     * getTips()
     *   .then(tips => {
     *     // ...
     *   })
     *   .catch(err => {
     *     // ...
     *   })
     * ```
     *
     * @method getTips
     *
     * @memberof module:core
     *
     * @param {Callback} [callback] - Optional callback
     *
     * @return {Promise}
     * @fulfil {Hash[]} List of tip hashes
     * @reject {Error}
     * - Fetch error
     */
    return function (callback) {
        return send({ command: types_1.IRICommand.GET_TIPS })
            .then(function (_a) {
            var hashes = _a.hashes;
            return hashes;
        })
            .asCallback(callback);
    };
};
//# sourceMappingURL=createGetTips.js.map